import axios from "axios";
const authTokenSet = token => {
    if (token) { //console.log('auth-yes');
        axios.defaults.headers.common["Authorization"] = token;
    } else { //console.log('auth-no'); 
       delete axios.defaults.headers.common["Authorization"];
    }
};
export default authTokenSet;    